import { PeanutIcon } from './PeanutIcon';

/**
 * author: Michael Richins
 * id 87A5BD64-6069-4C5B-8D50-69D9049B80BC
 * name peanut
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/peanut.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const AllergenIcon = PeanutIcon;
export default AllergenIcon